import { MarketplaceConfigUrls } from '@repo/types-client';

const _registry: Record<string, MarketplaceConfigUrls> = {
  mainnet: {
    indexerUrl: 'https://base-indexer.sequence.app',
    marketplaceUrl:
      'https://marketplace-api.sequence.app/base/rpc/Marketplace/',
  },
  sepolia: {
    indexerUrl: 'https://base-sepolia-indexer.sequence.app',
    marketplaceUrl:
      'https://marketplace-api.sequence.app/base-sepolia/rpc/Marketplace/',
  },
};

const defaultConfig: MarketplaceConfigUrls = {
  indexerUrl: 'https://base-sepolia-indexer.sequence.app',
  marketplaceUrl:
    'https://marketplace-api.sequence.app/base-sepolia/rpc/Marketplace/',
};

let _selectedNetwork: MarketplaceConfigUrls = defaultConfig;

switch (process.env.NEXT_PUBLIC_APP_ENV) {
  case 'production':
    _selectedNetwork = _registry.mainnet ?? defaultConfig;
    break;
  default:
    _selectedNetwork = _registry.sepolia ?? defaultConfig;
    break;
}

export const baseMarketplaceConfig =
  _selectedNetwork as Readonly<MarketplaceConfigUrls>;
